import {Component, NgModule} from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'master-layout',
  templateUrl: 'master-layout.component.html',
  styleUrls: ['master-layout.component.scss']
})
export class MasterLayoutComponent {
}
